import { User } from './DataType'


export const currentUser: User = {
    LastName: "Phan Thanh",
    FirstName: "Thắng",
    Gender: 0,
    Province: "Quảng Trị",
    District: "Hải Lăng",
    Ward: "Hải An",
    Address: "Thôn Mỹ Thủy",
    Email: "thanhthang.itsgu@gmail.com",
    Phone: "0355082545"
}

export const scheduleData = {
    "data": {
        "total_items": 19,
        "total_pages": 1,
        "ds_tiet_trong_ngay": [
            {
                "tiet": 1,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 2,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 3,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 4,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 5,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 6,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 7,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 8,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 9,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 10,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 11,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 12,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 13,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 14,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 15,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            },
            {
                "tiet": 16,
                "gio_bat_dau": "",
                "so_phut": 45,
                "nhhk": 20221
            }
        ],
        "ds_tuan_tkb": [
            {
                "tuan_hoc_ky": 1,
                "tuan_tuyet_doi": 1184,
                "thong_tin_tuan": "Tuần 1 [từ ngày 05/09/2022 đến ngày 11/09/2022]",
                "ngay_bat_dau": "05/09/2022",
                "ngay_ket_thuc": "11/09/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-06T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 2,
                "tuan_tuyet_doi": 1185,
                "thong_tin_tuan": "Tuần 2 [từ ngày 12/09/2022 đến ngày 18/09/2022]",
                "ngay_bat_dau": "12/09/2022",
                "ngay_ket_thuc": "18/09/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-13T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 3,
                "tuan_tuyet_doi": 1186,
                "thong_tin_tuan": "Tuần 3 [từ ngày 19/09/2022 đến ngày 25/09/2022]",
                "ngay_bat_dau": "19/09/2022",
                "ngay_ket_thuc": "25/09/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-20T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-22T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-22T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-23T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-23T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 4,
                "tuan_tuyet_doi": 1187,
                "thong_tin_tuan": "Tuần 4 [từ ngày 26/09/2022 đến ngày 02/10/2022]",
                "ngay_bat_dau": "26/09/2022",
                "ngay_ket_thuc": "02/10/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-27T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-29T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-29T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-30T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-09-30T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 5,
                "tuan_tuyet_doi": 1188,
                "thong_tin_tuan": "Tuần 5 [từ ngày 03/10/2022 đến ngày 09/10/2022]",
                "ngay_bat_dau": "03/10/2022",
                "ngay_ket_thuc": "09/10/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-04T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-06T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-06T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 6,
                "tuan_tuyet_doi": 1189,
                "thong_tin_tuan": "Tuần 6 [từ ngày 10/10/2022 đến ngày 16/10/2022]",
                "ngay_bat_dau": "10/10/2022",
                "ngay_ket_thuc": "16/10/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-11T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-13T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-13T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 7,
                "tuan_tuyet_doi": 1190,
                "thong_tin_tuan": "Tuần 7 [từ ngày 17/10/2022 đến ngày 23/10/2022]",
                "ngay_bat_dau": "17/10/2022",
                "ngay_ket_thuc": "23/10/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-18T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-20T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-20T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-22T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-22T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-22T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 8,
                "tuan_tuyet_doi": 1191,
                "thong_tin_tuan": "Tuần 8 [từ ngày 24/10/2022 đến ngày 30/10/2022]",
                "ngay_bat_dau": "24/10/2022",
                "ngay_ket_thuc": "30/10/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-25T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-27T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-27T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-29T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-29T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-29T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 9,
                "tuan_tuyet_doi": 1192,
                "thong_tin_tuan": "Tuần 9 [từ ngày 31/10/2022 đến ngày 06/11/2022]",
                "ngay_bat_dau": "31/10/2022",
                "ngay_ket_thuc": "06/11/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-31T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-31T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-10-31T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-02T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-02T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-04T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-04T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 10,
                "tuan_tuyet_doi": 1193,
                "thong_tin_tuan": "Tuần 10 [từ ngày 07/11/2022 đến ngày 13/11/2022]",
                "ngay_bat_dau": "07/11/2022",
                "ngay_ket_thuc": "13/11/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5757414383433908805",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 4,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-6474156015871583280",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-11T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-11T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 11,
                "tuan_tuyet_doi": 1194,
                "thong_tin_tuan": "Tuần 11 [từ ngày 14/11/2022 đến ngày 20/11/2022]",
                "ngay_bat_dau": "14/11/2022",
                "ngay_ket_thuc": "20/11/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 3,
                        "tiet_bat_dau": 6,
                        "so_tiet": 5,
                        "ma_mon": "862308",
                        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8893302225360433737",
                        "id_tkb": "-5933315008229233163",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "01",
                        "ma_giang_vien": "10784",
                        "ten_giang_vien": "Đào Công Nghĩa",
                        "ma_phong": "C.S_A05",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-18T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-18T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-19T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 12,
                "tuan_tuyet_doi": 1195,
                "thong_tin_tuan": "Tuần 12 [từ ngày 21/11/2022 đến ngày 27/11/2022]",
                "ngay_bat_dau": "21/11/2022",
                "ngay_ket_thuc": "27/11/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-21T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-23T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-23T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-24T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-25T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-25T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-26T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 13,
                "tuan_tuyet_doi": 1196,
                "thong_tin_tuan": "Tuần 13 [từ ngày 28/11/2022 đến ngày 04/12/2022]",
                "ngay_bat_dau": "28/11/2022",
                "ngay_ket_thuc": "04/12/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-28T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-30T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-11-30T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-01T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-02T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-02T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-03T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 14,
                "tuan_tuyet_doi": 1197,
                "thong_tin_tuan": "Tuần 14 [từ ngày 05/12/2022 đến ngày 11/12/2022]",
                "ngay_bat_dau": "05/12/2022",
                "ngay_ket_thuc": "11/12/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-05T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-07T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-08T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-09T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-10T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 15,
                "tuan_tuyet_doi": 1198,
                "thong_tin_tuan": "Tuần 15 [từ ngày 12/12/2022 đến ngày 18/12/2022]",
                "ngay_bat_dau": "12/12/2022",
                "ngay_ket_thuc": "18/12/2022 23:59:59",
                "ds_thoi_khoa_bieu": [
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 1,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7765582083733414221",
                        "id_tkb": "-6757813414705134159",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.B109",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 2,
                        "tiet_bat_dau": 3,
                        "so_tiet": 2,
                        "ma_mon": "CALO11",
                        "ten_mon": "Cầu lông 1",
                        "so_tin_chi": "1",
                        "id_to_hoc": "-6340304687802925612",
                        "id_tkb": "-7022505669589151117",
                        "id_to_hop": "0",
                        "ma_nhom": "11",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10802",
                        "ten_giang_vien": "Nguyễn Đỗ Minh Sơn",
                        "ma_phong": "C.SCL02",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-12T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841068",
                        "ten_mon": "Hệ thống thông tin doanh nghiệp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7495386060128248207",
                        "id_tkb": "-7882095189008497093",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11363",
                        "ten_giang_vien": "Lê Nhị Lãm Thúy",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 4,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6089269856229141696",
                        "id_tkb": "-6320204827554749686",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-14T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-7366839437772349317",
                        "id_tkb": "-4689866427769561144",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 5,
                        "tiet_bat_dau": 8,
                        "so_tiet": 3,
                        "ma_mon": "841411",
                        "ten_mon": "Quản trị mạng",
                        "so_tin_chi": "4",
                        "id_to_hoc": "-5265227575618587759",
                        "id_tkb": "-8313048083380142421",
                        "id_to_hop": "0",
                        "ma_nhom": "01",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11364",
                        "ten_giang_vien": "Lương Minh Huấn",
                        "ma_lop": "DCT1202",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-15T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 2,
                        "so_tiet": 2,
                        "ma_mon": "841113",
                        "ten_mon": "Phát triển phần mềm mã nguồn mở",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6030310941106600828",
                        "id_tkb": "-6705421132857908694",
                        "id_to_hop": "0",
                        "ma_nhom": "02",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "10600,20730",
                        "ten_giang_vien": "Nguyễn Trường Hải",
                        "ma_lop": "DCT1192",
                        "ma_phong": "C.E305",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 6,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-7756834258952094877",
                        "id_tkb": "-8763974486728476828",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.E402",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-16T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 4,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-6813376464074947195",
                        "id_tkb": "-6385483184984004319",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.A304",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 6,
                        "so_tiet": 2,
                        "ma_mon": "841307",
                        "ten_mon": "Lập trình mạng",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-8534990495498289027",
                        "id_tkb": "-6272782833985663148",
                        "id_to_hop": "0",
                        "ma_nhom": "05",
                        "ma_to_th": "01",
                        "ma_to_hop": "",
                        "ma_giang_vien": "11033",
                        "ten_giang_vien": "Trần Minh Nhật",
                        "ma_lop": "DCT1191",
                        "ma_phong": "C.HB403",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    },
                    {
                        "is_hk_lien_truoc": 0,
                        "thu_kieu_so": 7,
                        "tiet_bat_dau": 8,
                        "so_tiet": 2,
                        "ma_mon": "841052",
                        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
                        "so_tin_chi": "3",
                        "id_to_hoc": "-5196294373263708132",
                        "id_tkb": "-5125507083339020019",
                        "id_to_hop": "0",
                        "ma_nhom": "03",
                        "ma_to_th": "",
                        "ma_to_hop": "",
                        "ma_giang_vien": "20764",
                        "ten_giang_vien": "Mai Vân Phương Vũ",
                        "ma_lop": "DCT1193",
                        "ma_phong": "C.PHA",
                        "ma_co_so": "C",
                        "ngay_hoc": "2022-12-17T00:00:00",
                        "id_tu_tao": "0",
                        "is_file_bai_giang": false,
                        "id_sinh_hoat": "0"
                    }
                ],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 16,
                "tuan_tuyet_doi": 1199,
                "thong_tin_tuan": "Tuần 16 [từ ngày 19/12/2022 đến ngày 25/12/2022]",
                "ngay_bat_dau": "19/12/2022",
                "ngay_ket_thuc": "25/12/2022 23:59:59",
                "ds_thoi_khoa_bieu": [],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 17,
                "tuan_tuyet_doi": 1200,
                "thong_tin_tuan": "Tuần 17 [từ ngày 26/12/2022 đến ngày 01/01/2023]",
                "ngay_bat_dau": "26/12/2022",
                "ngay_ket_thuc": "01/01/2023 23:59:59",
                "ds_thoi_khoa_bieu": [],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 18,
                "tuan_tuyet_doi": 1201,
                "thong_tin_tuan": "Tuần 18 [từ ngày 02/01/2023 đến ngày 08/01/2023]",
                "ngay_bat_dau": "02/01/2023",
                "ngay_ket_thuc": "08/01/2023 23:59:59",
                "ds_thoi_khoa_bieu": [],
                "ds_id_thoi_khoa_bieu_trung": []
            },
            {
                "tuan_hoc_ky": 19,
                "tuan_tuyet_doi": 1202,
                "thong_tin_tuan": "Tuần 19 [từ ngày 09/01/2023 đến ngày 15/01/2023]",
                "ngay_bat_dau": "09/01/2023",
                "ngay_ket_thuc": "15/01/2023 23:59:59",
                "ds_thoi_khoa_bieu": [],
                "ds_id_thoi_khoa_bieu_trung": []
            }
        ],
        "is_duoc_diem_danh": false,
        "is_duoc_dk_nghi_day": false,
        "is_quan_ly_hoc_lieu": false,
        "is_show_tiet": true
    },
    "result": true,
    "code": 200
}

export const scheduleSemester = [
    {
        "id_to_hoc": "-7756834258952094877",
        "id_mon": "0",
        "ma_mon": "841052",
        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "03-01",
        "lop": "DCT1193",
        "ds_lop": [
            "DCT1193"
        ],
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "09/09/22 đến 16/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 6,
        "tbd": 4,
        "so_tiet": 2,
        "tu_gio": "09:50",
        "den_gio": "10:40",
        "phong": "C.E402",
        "gv": "M.V.P.Vũ",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-7756834258952094877",
        "id_mon": "0",
        "ma_mon": "841052",
        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "03-01",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "10/09/22 đến 17/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 7,
        "tbd": 8,
        "so_tiet": 2,
        "tu_gio": "15:00",
        "den_gio": "15:50",
        "phong": "C.PHA",
        "gv": "M.V.P.Vũ",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-7495386060128248207",
        "id_mon": "0",
        "ma_mon": "841068",
        "ten_mon": "Hệ thống thông tin doanh nghiệp",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "02-01",
        "lop": "DCT1192",
        "ds_lop": [
            "DCT1192"
        ],
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "07/09/22 đến 14/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 4,
        "tbd": 6,
        "so_tiet": 2,
        "tu_gio": "13:00",
        "den_gio": "13:50",
        "phong": "C.E403",
        "gv": "L.N.L.Thúy",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-7495386060128248207",
        "id_mon": "0",
        "ma_mon": "841068",
        "ten_mon": "Hệ thống thông tin doanh nghiệp",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "02-01",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "05/09/22 đến 12/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 2,
        "tbd": 1,
        "so_tiet": 2,
        "tu_gio": "07:00",
        "den_gio": "07:50",
        "phong": "C.B109",
        "gv": "L.N.L.Thúy",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-6089269856229141696",
        "id_mon": "0",
        "ma_mon": "841113",
        "ten_mon": "Phát triển phần mềm mã nguồn mở",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "02-01",
        "lop": "DCT1192",
        "ds_lop": [
            "DCT1192"
        ],
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "07/09/22 đến 14/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 4,
        "tbd": 8,
        "so_tiet": 2,
        "tu_gio": "15:00",
        "den_gio": "15:50",
        "phong": "C.E402",
        "gv": "N.T.Hải",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-6089269856229141696",
        "id_mon": "0",
        "ma_mon": "841113",
        "ten_mon": "Phát triển phần mềm mã nguồn mở",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "02-01",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "09/09/22 đến 16/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 6,
        "tbd": 2,
        "so_tiet": 2,
        "tu_gio": "07:50",
        "den_gio": "09:00",
        "phong": "C.E305",
        "gv": "N.T.Hải",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-8534990495498289027",
        "id_mon": "0",
        "ma_mon": "841307",
        "ten_mon": "Lập trình mạng",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "05-01",
        "lop": "DCT1191",
        "ds_lop": [
            "DCT1191"
        ],
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "10/09/22 đến 17/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 7,
        "tbd": 6,
        "so_tiet": 2,
        "tu_gio": "13:00",
        "den_gio": "13:50",
        "phong": "C.HB403",
        "gv": "T.M.Nhật",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-8534990495498289027",
        "id_mon": "0",
        "ma_mon": "841307",
        "ten_mon": "Lập trình mạng",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "05-01",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "10/09/22 đến 17/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 7,
        "tbd": 4,
        "so_tiet": 2,
        "tu_gio": "09:50",
        "den_gio": "10:40",
        "phong": "C.A304",
        "gv": "T.M.Nhật",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-7366839437772349317",
        "id_mon": "0",
        "ma_mon": "841411",
        "ten_mon": "Quản trị mạng",
        "so_tc": "4",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "01-01",
        "lop": "DCT1202",
        "ds_lop": [
            "DCT1202"
        ],
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "08/09/22 đến 15/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 5,
        "tbd": 6,
        "so_tiet": 2,
        "tu_gio": "13:00",
        "den_gio": "13:50",
        "phong": "C.E402",
        "gv": "L.M.Huấn",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-7366839437772349317",
        "id_mon": "0",
        "ma_mon": "841411",
        "ten_mon": "Quản trị mạng",
        "so_tc": "4",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "01-01",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "08/09/22 đến 15/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 5,
        "tbd": 8,
        "so_tiet": 3,
        "tu_gio": "15:00",
        "den_gio": "16:40",
        "phong": "C.E305",
        "gv": "L.M.Huấn",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-8893302225360433737",
        "id_mon": "0",
        "ma_mon": "862308",
        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "05",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "05/09/22 đến 07/11/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 2,
        "tbd": 6,
        "so_tiet": 4,
        "tu_gio": "13:00",
        "den_gio": "15:50",
        "phong": "C.S_A05",
        "gv": "Đ.C.Nghĩa",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-8893302225360433737",
        "id_mon": "0",
        "ma_mon": "862308",
        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "05",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "06/09/22 đến 08/11/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 3,
        "tbd": 6,
        "so_tiet": 4,
        "tu_gio": "13:00",
        "den_gio": "15:50",
        "phong": "C.S_A05",
        "gv": "Đ.C.Nghĩa",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-8893302225360433737",
        "id_mon": "0",
        "ma_mon": "862308",
        "ten_mon": "Giáo dục quốc phòng và An ninh 3",
        "so_tc": "3",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "05",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "15/11/22 đến 15/11/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 3,
        "tbd": 6,
        "so_tiet": 5,
        "tu_gio": "13:00",
        "den_gio": "16:40",
        "phong": "C.S_A05",
        "gv": "Đ.C.Nghĩa",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    },
    {
        "id_to_hoc": "-6340304687802925612",
        "id_mon": "0",
        "ma_mon": "CALO11",
        "ten_mon": "Cầu lông 1",
        "so_tc": "1",
        "so_tc_so": 0,
        "is_vuot": false,
        "nhom_to": "11",
        "lop": "",
        "is_kdk": false,
        "sl_dk": 0,
        "sl_cp": 0,
        "sl_cl": 0,
        "tkb": "05/09/22 đến 12/12/22",
        "is_hl": false,
        "enable": false,
        "hauk": false,
        "is_dk": false,
        "is_rot": false,
        "is_ctdt": false,
        "is_chctdt": false,
        "is_kg_lt": false,
        "thu": 2,
        "tbd": 3,
        "so_tiet": 2,
        "tu_gio": "09:00",
        "den_gio": "09:50",
        "phong": "C.SCL02",
        "gv": "N.Đ.M.Sơn",
        "gc_to_hoc": "",
        "is_kg_huy_kqdk": false
    }
]

export const DataExam = [
    {
        "so_thu_tu": 1,
        "ky_thi": "Thi kết thúc môn",
        "dot_thi": "2",
        "ma_mon": "841411",
        "ten_mon": "Quản trị mạng",
        "ma_phong": "C.A502",
        "ma_co_so": "C",
        "ngay_thi": "11/01/2023",
        "tiet_bat_dau": "1",
        "so_tiet": "2",
        "gio_bat_dau": "07:00",
        "so_phut": "100",
        "hinh_thuc_thi": "Viết",
        "ghi_chu_sv": "",
        "ghep_thi": "DCT1202_01",
        "to_thi": "003",
        "nhom_thi": "DCT1202_01",
        "ghep_phong": "",
        "ghi_chu_htt": "Viết",
        "ghi_chu_du_thi": "",
        "cam_thi": "",
        "si_so": 24,
        "xem_dssv": "Xem",
        "dia_diem_thi": "Phòng học Cơ sở Chính -                                                                                                                                                                                                                                                               ",
        "ds_diem_mon_hoc": [
            {
                "ten_mon": "",
                "mon_hoc_nganh": false,
                "ket_qua": 0,
                "hien_thi_ket_qua": false,
                "KhoaThi": 0,
                "ds_diem_thanh_phan": []
            }
        ]
    },
    {
        "so_thu_tu": 2,
        "ky_thi": "Thi kết thúc môn",
        "dot_thi": "2",
        "ma_mon": "841068",
        "ten_mon": "Hệ thống thông tin doanh nghiệp",
        "ma_phong": "C.A307",
        "ma_co_so": "C",
        "ngay_thi": "09/01/2023",
        "tiet_bat_dau": "1",
        "so_tiet": "2",
        "gio_bat_dau": "07:00",
        "so_phut": "100",
        "hinh_thuc_thi": "Viết",
        "ghi_chu_sv": "",
        "ghep_thi": "DCT1192_02",
        "to_thi": "003",
        "nhom_thi": "DCT1192_02",
        "ghep_phong": "",
        "ghi_chu_htt": "Viết",
        "ghi_chu_du_thi": "",
        "cam_thi": "",
        "si_so": 26,
        "xem_dssv": "Xem",
        "dia_diem_thi": "Phòng học Cơ sở Chính -                                                                                                                                                                                                                                                               ",
        "ds_diem_mon_hoc": [
            {
                "ten_mon": "",
                "mon_hoc_nganh": false,
                "ket_qua": 0,
                "hien_thi_ket_qua": false,
                "KhoaThi": 0,
                "ds_diem_thanh_phan": []
            }
        ]
    },
    {
        "so_thu_tu": 3,
        "ky_thi": "Thi kết thúc môn",
        "dot_thi": "2",
        "ma_mon": "841052",
        "ten_mon": "Xây dựng phần mềm theo mô hình phân lớp",
        "ma_phong": "C.E301",
        "ma_co_so": "C",
        "ngay_thi": "09/01/2023",
        "tiet_bat_dau": "4",
        "so_tiet": "2",
        "gio_bat_dau": "09:30",
        "so_phut": "100",
        "hinh_thuc_thi": "Viết",
        "ghi_chu_sv": "",
        "ghep_thi": "DCT1193_03",
        "to_thi": "003",
        "nhom_thi": "DCT1193_03",
        "ghep_phong": "",
        "ghi_chu_htt": "Viết",
        "ghi_chu_du_thi": "",
        "cam_thi": "",
        "si_so": 25,
        "xem_dssv": "Xem",
        "dia_diem_thi": "Phòng học Cơ sở Chính -                                                                                                                                                                                                                                                               ",
        "ds_diem_mon_hoc": [
            {
                "ten_mon": "",
                "mon_hoc_nganh": false,
                "ket_qua": 0,
                "hien_thi_ket_qua": false,
                "KhoaThi": 0,
                "ds_diem_thanh_phan": []
            }
        ]
    },
    {
        "so_thu_tu": 4,
        "ky_thi": "Thi kết thúc môn",
        "dot_thi": "2",
        "ma_mon": "841307",
        "ten_mon": "Lập trình mạng",
        "ma_phong": "C.E601",
        "ma_co_so": "C",
        "ngay_thi": "05/01/2023",
        "tiet_bat_dau": "9",
        "so_tiet": "2",
        "gio_bat_dau": "15:00",
        "so_phut": "180",
        "hinh_thuc_thi": "Viết",
        "ghi_chu_sv": "",
        "ghep_thi": "DCT1191_05",
        "to_thi": "003",
        "nhom_thi": "DCT1191_05",
        "ghep_phong": "",
        "ghi_chu_htt": "Viết",
        "ghi_chu_du_thi": "",
        "cam_thi": "",
        "si_so": 23,
        "xem_dssv": "Xem",
        "dia_diem_thi": "Phòng học Cơ sở Chính -                                                                                                                                                                                                                                                               ",
        "ds_diem_mon_hoc": [
            {
                "ten_mon": "",
                "mon_hoc_nganh": false,
                "ket_qua": 0,
                "hien_thi_ket_qua": false,
                "KhoaThi": 0,
                "ds_diem_thanh_phan": []
            }
        ]
    },
    {
        "so_thu_tu": 5,
        "ky_thi": "Thi kết thúc môn",
        "dot_thi": "2",
        "ma_mon": "841113",
        "ten_mon": "Phát triển phần mềm mã nguồn mở",
        "ma_phong": "C.A503",
        "ma_co_so": "C",
        "ngay_thi": "04/01/2023",
        "tiet_bat_dau": "6",
        "so_tiet": "2",
        "gio_bat_dau": "12:30",
        "so_phut": "100",
        "hinh_thuc_thi": "Viết",
        "ghi_chu_sv": "",
        "ghep_thi": "DCT1192_02",
        "to_thi": "002",
        "nhom_thi": "DCT1192_02",
        "ghep_phong": "",
        "ghi_chu_htt": "Viết",
        "ghi_chu_du_thi": "",
        "cam_thi": "",
        "si_so": 32,
        "xem_dssv": "Xem",
        "dia_diem_thi": "Phòng học Cơ sở Chính -                                                                                                                                                                                                                                                               ",
        "ds_diem_mon_hoc": [
            {
                "ten_mon": "",
                "mon_hoc_nganh": false,
                "ket_qua": 0,
                "hien_thi_ket_qua": false,
                "KhoaThi": 0,
                "ds_diem_thanh_phan": []
            }
        ]
    }
]